"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const arrow_down_1 = require("../icons/arrow-down");
exports.default = arrow_down_1.ArrowDown;
